import type { Dict } from "../en";

export const inbox: Dict["inbox"] = {
  readingPane: "Khung đọc",
  pickItem: "Chọn một mục để đọc ở đây.",
  openInConversation: "Mở trong cuộc trò chuyện",
  copyLink: "Sao chép liên kết",
  linkCopied: "Đã sao chép liên kết",
  them: "họ",
  replyGoesBack:
    "Trả lời của bạn sẽ được gửi lại cho {name}, ngay nơi họ đã hỏi. Mở đầu bằng “Vantage,” nếu muốn hỏi Vantage.",
  replyTo: "Trả lời {name}",
  replyToPlaceholder: "Trả lời {name}…",
  replyToVantage: "Trả lời Vantage",
  askFollowUp: "Hỏi thêm…",
  messageGone: "Tin nhắn này không còn",
  mayBeDeleted: "Có thể nó đã bị xóa.",
  answerInReport: "Câu trả lời sẽ nằm trong cuộc trò chuyện của báo cáo.",
  // the filter chips
  filterAll: "Tất cả",
  filterUnread: "Chưa đọc",
  filterRelay: "Lời nhắn",
  filterReport: "Báo cáo",
  filterReminder: "Lời nhắc",
  filterAlert: "Cảnh báo",
  fromRelay: "Từ {name} · trả lời của bạn sẽ được gửi lại cho họ",
  aRelay: "Một lời nhắn",
  yourReminder: "Lời nhắc của bạn",
  inChannel: "Trong #{slug}",
  fromPersonal: "Từ cuộc trò chuyện của bạn với Vantage",
  fromDm: "Từ một tin nhắn riêng",
  fromVantage: "Từ Vantage",
  emptyAllTitle: "Chưa có gì ở đây",
  emptyAllBody: "Báo cáo bạn yêu cầu, lời nhắn gửi đến bạn và lời nhắc của bạn sẽ xuất hiện ở đây.",
  emptyUnreadTitle: "Đã đọc hết",
  emptyUnreadBody: "Không có gì chưa đọc.",
  emptyRelayTitle: "Chưa có lời nhắn",
  emptyRelayBody: "Khi ai đó nhờ Vantage nhắn bạn điều gì, nó sẽ ở đây.",
  emptyReportTitle: "Chưa có báo cáo",
  emptyReportBody: "Khi báo cáo bạn yêu cầu đã sẵn sàng, nó sẽ xuất hiện ở đây.",
  emptyReminderTitle: "Chưa có lời nhắc",
  emptyReminderBody: "Nhờ Vantage nhắc bạn, lời nhắc sẽ xuất hiện ở đây.",
  emptyAlertTitle: "Chưa có cảnh báo",
  emptyAlertBody: "Cảnh báo từ các tác vụ tự động sẽ xuất hiện ở đây.",
};
